import { render } from "./PatientsList.vue?vue&type=template&id=6b70e654"
import script from "./PatientsList.vue?vue&type=script&lang=js"
export * from "./PatientsList.vue?vue&type=script&lang=js"

import "./PatientsList.vue?vue&type=style&index=0&id=6b70e654&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__